var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrosshair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 176.13 178.91",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-180.17 -248.48)",
    stroke: "#f00"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.0697 0 0 1.0697 69.611 145.44)",
    d: "m247.25 179.95c0 35.589-27.568 64.439-61.575 64.439s-61.575-28.85-61.575-64.439 27.568-64.439 61.575-64.439 61.575 28.85 61.575 64.439z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.76407 0 0 .76407 126.36 200.44)",
    d: "m247.25 179.95c0 35.589-27.568 64.439-61.575 64.439s-61.575-28.85-61.575-64.439 27.568-64.439 61.575-64.439 61.575 28.85 61.575 64.439z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.45844 0 0 .45844 183.11 255.44)",
    d: "m247.25 179.95c0 35.589-27.568 64.439-61.575 64.439s-61.575-28.85-61.575-64.439 27.568-64.439 61.575-64.439 61.575 28.85 61.575 64.439z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f00"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.34,
    y: 249.08,
    width: 1.7837,
    height: 58.784,
    strokeLinecap: "round",
    strokeWidth: 1.216
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.2163
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.34,
    y: 368,
    width: 1.7837,
    height: 58.784
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90)",
    x: 337.04,
    y: -355.69,
    width: 1.7837,
    height: 58.784
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90)",
    x: 337.04,
    y: -239.56,
    width: 1.7837,
    height: 58.784
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 238.23,
    y: 337.78,
    width: 60,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90)",
    x: 307.93,
    y: -268.38,
    width: 60,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.72,
    y: 332.13,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.72,
    y: 314.13,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.72,
    y: 320.13,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.72,
    y: 326.13,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.75,
    y: 360.74,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.75,
    y: 342.74,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.75,
    y: 348.74,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.75,
    y: 354.74,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90)",
    x: 336.42,
    y: -274.04,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90)",
    x: 336.42,
    y: -292.04,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90)",
    x: 336.42,
    y: -286.04,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90)",
    x: 336.42,
    y: -280.04,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90)",
    x: 336.45,
    y: -245.43,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90)",
    x: 336.45,
    y: -263.43,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90)",
    x: 336.45,
    y: -257.43,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90)",
    x: 336.45,
    y: -251.43,
    width: 3,
    height: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrosshair);
export default __webpack_public_path__ + "static/media/crosshair.835c35bb8b808f66cd22ef83209170c4.svg";
export { ForwardRef as ReactComponent };